/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import Numeric from '../../numeric/numeric';

/**
 * @import { Byte } from '../../byte'
 * @import  { FileSystemUnit } from '.'
 */

/**
 * Detektor volného místa na disku.
 */
export default class FileSystemSpaceDetector {
  /**
   * Detekuje, jestli je na disku dostatek volného místa.
   * @param {FileSystemUnit} fileSystemUnit Fyzická jednotka.
   * @param {Byte} size Velikost požadovaného místa.
   * @returns {Promise<boolean>} Příznak, jestli je dostatek volného místa.
   */
  static async detect(fileSystemUnit, size) {
    if (!Numeric.isIndex(size)) {
      throw new TypeError(`Invalid size ${size}.`);
    }
    // Porovnání volného místa s požadovaným.
    const { free } = await fileSystemUnit.getInfo();
    return free >= size;
  }
}
